import { apiClient } from './client';
import type { DynamicRuleBuildRequest, DynamicRuleBuildResult, DynamicRuleSearchResult } from '@/types/oscar';

/**
 * GET /api/dynamic-rules/search — every Entra dynamic group rule and Exchange
 * dynamic distribution group filter containing `q` (admin/helpdesk). Each source
 * reports its own status, so one being unreadable never hides the other's hits.
 * `refresh` skips the server's 5-minute cache and re-reads both directories.
 */
export function searchDynamicRules(q: string, refresh = false, signal?: AbortSignal): Promise<DynamicRuleSearchResult> {
  const params = new URLSearchParams({ q });
  if (refresh) params.set('refresh', 'true');
  return apiClient.get<DynamicRuleSearchResult>(`/api/dynamic-rules/search?${params.toString()}`, signal);
}

/**
 * POST /api/dynamic-rules/build — an Entra dynamic membership rule for the picked
 * departments, titles and named people, plus who Oscar thinks it would catch
 * (admin/helpdesk). Read-only: the team pastes the rule into Entra themselves.
 * POST because the body carries people's object ids, which stay out of URLs.
 */
export function buildDynamicRule(body: DynamicRuleBuildRequest, signal?: AbortSignal): Promise<DynamicRuleBuildResult> {
  return apiClient.post<DynamicRuleBuildResult>('/api/dynamic-rules/build', body, signal);
}
